import React from 'react';
import type { TransferredInAssociateProfilePlacement } from 'src/services/associateProfile/types';
import PlacementInfo from './placementInfo';
import PlacementCardLayout from './placementCardLayout';

interface TransferredInPlacementCardProps {
  placement: TransferredInAssociateProfilePlacement;
}

const TransferredInPlacementCard = ({ placement }: TransferredInPlacementCardProps) => {
  return (
    <PlacementCardLayout placement={placement}>
      <PlacementInfo label="Injury" value={placement.injury} />
      <PlacementInfo label="Transferred from" value={placement.transferredFrom} />
      <PlacementInfo label="Transfer Date" value={new Date(placement.transferAtDate).toLocaleDateString()} />
      <PlacementInfo label="Time In Transfer" value={placement.timeInTransfer} />
      <PlacementInfo label="Transferred By" value={placement.updatedBy} />
    </PlacementCardLayout>
  );
};

export default TransferredInPlacementCard;
